/* eslint no-undef: "off" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    reCaptchaPublicKey: PropTypes.string.isRequired,
    elementID: PropTypes.string,
    expiredCallback: PropTypes.func,
    onloadCallbackName: PropTypes.string,
    onloadCallback: PropTypes.func,
    render: PropTypes.string,
    reset: PropTypes.number,
    size: PropTypes.string,
    theme: PropTypes.string,
    type: PropTypes.string,
    verifyCallback: PropTypes.func,
    clsName: PropTypes.string
};

const defaultProps = {
    clsName: undefined,
    elementID: 'g-recaptcha',
    expiredCallback: undefined,
    onloadCallback: undefined,
    onloadCallbackName: 'recaptchaLoaded',
    render: 'explicit',
    reset: 0,
    size: typeof window !== 'undefined' && window.innerWidth < 768 ? 'compact' : 'normal',
    theme: 'light',
    type: 'image',
    verifyCallback: undefined
};

class ReCaptchaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reCaptcha: {}
        };

        // Check we're client side rendering
        // If we are , provide the callback for 3rd party recaptcha
        if (typeof window !== 'undefined') {
            window[this.props.onloadCallbackName] = function () {
                this.loadReCaptcha();
                if (this.props.onloadCallback) {
                    this.props.onloadCallback();
                }
            }.bind(this);
        }
    }

    loadReCaptcha() {
        const reCaptcha = grecaptcha.render(this.props.elementID, {
            'sitekey': this.props.reCaptchaPublicKey,
            'callback': this.props.verifyCallback,
            'expired-callback': this.props.expiredCallback,
            'theme': this.props.theme,
            'render': this.props.render,
            'type': this.props.type,
            'size': this.props.size,
            'clsName': this.props.clsName
        });
        this.setState({ reCaptcha });
    }

    componentWillUnmount() {
        this.resetCaptcha();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.reset !== nextProps.reset && nextProps.reset) {
            this.resetCaptcha();
        }
    }

    resetCaptcha() {
        if (typeof grecaptcha !== 'undefined') {
            grecaptcha.reset(this.state.reCaptcha);
        }
    }

    render() {
        return (
            <div className="asc-form-group">
                <div className={this.props.clsName} id={this.props.elementID} />
            </div>
        );
    }
}

ReCaptchaContainer.propTypes = propTypes;
ReCaptchaContainer.defaultProps = defaultProps;
export default ReCaptchaContainer;
